import { SUPPLIER_FACILITY_REVIEWS_CRUD_ACTION_CONSTANTS as CRUD_ACTION_CONSTANTS } from '../actions/supplier_facility_reviews_actions';
import { standardInitialStateGenerator, standardReducerGenerator } from './standard_reducer_utils';

const initialState: any = standardInitialStateGenerator(['supplierDetailReviews']);
export default standardReducerGenerator(CRUD_ACTION_CONSTANTS, initialState);
